var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDuplicateContent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 10.991A2.01 2.01 0 0 0 4.009 13H12a2.01 2.01 0 0 1-2.009 2H2.01A2.01 2.01 0 0 1 0 12.991V5.01C0 3.902.9 3 2.009 3H2zM12.991 0C14.098 0 15 .9 15 2.009V9.99A2.01 2.01 0 0 1 12.991 12H5.01A2.01 2.01 0 0 1 3 9.991V2.01C3 .902 3.9 0 5.009 0Zm-.988 2H5.997C5.447 2 5 2.453 5 2.997v6.006c0 .55.453.997.997.997h6.006c.55 0 .997-.453.997-.997V2.997c0-.55-.453-.997-.997-.997M10 3v2h2v2h-2v2H8V7H6V5h2V3z"
})));
export default SvgDuplicateContent;